import { useWeb3React } from "@web3-react/core";
import { useEffect, useState } from "react";
import { useWeb3Context } from "./web3Context";
import { IERC20Factory } from "../codegen/IERC20Factory";
import { getERC20TokenAddress } from "../constants/constants";
export var getERC20Token = function (library, token, chainId, useSigner) {
    if (useSigner === void 0) { useSigner = true; }
    var address = getERC20TokenAddress(token, chainId);
    if (library && address) {
        var provider = useSigner ? library.getSigner() : library;
        return IERC20Factory.connect(address, provider);
    }
    return undefined;
};
var useERC20Token = function (token) {
    var _a = useWeb3React(), active = _a.active, chainId = _a.chainId, library = _a.library;
    var provider = useWeb3Context().provider;
    var _b = useState(), contract = _b[0], setContract = _b[1];
    useEffect(function () {
        if (provider && chainId) {
            setContract(getERC20Token(library || provider, token, chainId, active));
        }
    }, [chainId, provider, active, library, token]);
    return contract;
};
export default useERC20Token;
//# sourceMappingURL=useERC20Token.js.map